var PromiseEnv = require('core/lib/promise').Promise;

var poll = require('./poll').poll;

/**
 * Returns a promise that is resolved when a condition is satisfied.
 * @param {function} conditionFn A function that executes synchronously and returns a truthy value when
 *                               the condition is met
 * @returns {Promise}
 */
exports.waitUntil = function(conditionFn:Function): Promise<any> {
  return new PromiseEnv(function(resolve, reject) {
    if (conditionFn()) {
      resolve();
      return;
    }
    var cancelPolling = poll(function() {
      if (conditionFn()) {
        cancelPolling();
        resolve();
      }
    });
  });
};
